import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/industries.css';
import healthcareImg from '../../assets/healthcare.jpg';

const Healthcare = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${healthcareImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Healthcare</h1>
      <p>
        Empowering healthcare with technology for better patient care, secure records, and smart diagnostics.
      </p>
      <ul className="bullet-points">
        <li>🏥 Hospital Management Systems.</li>
        <li>📋 EMR/EHR platforms.</li>
        <li>🩻 AI-powered diagnostics.</li>
        <li>📞 Telemedicine & remote consultation.</li>
        <li>🤖 AI-driven medical report analysis. </li>
      </ul>
    </motion.div>
  </div>
);

export default Healthcare;
